module.exports = __webpack_public_path__ + "static/media/alerta.9fffdcfd.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Images/Others/alerta.svg
// module id = 1824
// module chunks = 0